import { camelCase as camelCaseKeys } from '@teamleader/api';

import { getAccessToken, getAuthenticatedUser, User } from '../AuthenticationService';
import { ConsentCategory } from '../ConsentService';

import { SurveyListResponsePayload } from './types';
import { isLeadSelfEmployed } from './util';

export const show = () => {
  if (window.HubSpotConversations) {
    window.HubSpotConversations.widget.load({ widgetOpen: false });
  }
};

export const hide = () => {
  if (window.HubSpotConversations) {
    window.HubSpotConversations.widget.remove();
  }
};

const loadIsLeadSelfEmployed = async () => {
  return getAccessToken()
    .then((accessToken: string) => {
      return fetch(`${environment.SIGNUP_API_URL}/api/surveys.list`, {
        method: 'POST',
        headers: {
          authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          filter: {
            type: 'signup_wizard',
          },
        }),
      });
    })
    .then((data: Response) => data.json())
    .then((payload) => camelCaseKeys(payload?.data))
    .then((surveys: SurveyListResponsePayload) => isLeadSelfEmployed(surveys));
};

const loadHubSpotChat = () => {
  window.hsConversationsSettings = {
    loadImmediately: false,
  };

  const elementId = 'hs-script-loader';
  const script = window.document.createElement('script');

  script.setAttribute('id', elementId);
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('src', `//js.hs-scripts.com/${environment.HUBSPOT_PORTAL_ID}.js`);
  script.setAttribute('defer', 'defer');
  script.setAttribute('async', 'true');
  script.setAttribute('data-cookieconsent', ConsentCategory.Necessary);
  window.document.head.appendChild(script);

  const style = window.document.createElement('style');

  style.innerText = '#hubspot-messages-iframe-container { z-index: 500; }';
  window.document.body.appendChild(style);
};

const identifyHubspotChat = () => {
  getAccessToken()
    .then((accessToken: string) => {
      return fetch(`${environment.HUBSPOT_URL}/api/visitors.identify`, {
        method: 'POST',
        headers: {
          authorization: 'Bearer ' + accessToken,
        },
      });
    })
    .then((data: Response) => {
      return data.json();
    })
    .then((payload: { data?: { token: string } }) => {
      if (!payload.data) {
        return;
      }

      window.hsConversationsSettings = {
        loadImmediately: false,
        identificationEmail: window.TLGLOBALS.EMAIL,
        identificationToken: payload.data.token,
      };

      function onConversationsAPIReady() {
        window.HubSpotConversations && window.HubSpotConversations.widget.load({ widgetOpen: false });
      }

      if (window.HubSpotConversations) {
        onConversationsAPIReady();
      } else {
        window.hsConversationsOnReady = [onConversationsAPIReady];
      }
    });
};

const addEventListeners = () => {
  const hideListeners = ['TL.Core.Layout.sidePanelOpened', 'TL.Core.deactivateUsersNotificationShown'];
  const showListeners = ['TL.Core.Layout.sidePanelClosed', 'TL.Core.deactivateUsersNotificationHidden'];

  hideListeners.forEach((listener) => {
    window.addEventListener(listener, hide);
  });

  showListeners.forEach((listener) => {
    window.addEventListener(listener, show);
  });
};

export const initialize = async () => {
  const canAccessSalesChat = getAuthenticatedUser(User.CanAccessInAppSalesChat);
  if (!canAccessSalesChat) {
    return;
  }

  const isLeadSelfEmployed = await loadIsLeadSelfEmployed();

  if (isLeadSelfEmployed) {
    // Hide the chat for self-employed leads

    return;
  }

  loadHubSpotChat();
  identifyHubspotChat();

  addEventListeners();
};
